import $http from "../../helpers/api";
import {
    objectToFormData
} from "../../helpers/formdata";

// initial state
const state = {
    all: [],
    model: []
};

// getters
const getters = {
    get: state => state.model,
    getAll: state => state.all
};

// actions
const actions = {
    getAll({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $http.get("/models").then(resp => {
                console.log(resp);
                commit("setAll", resp.data);
            });
            resolve();
        });
    },
    get({
        commit
    }, modelId) {
        return new Promise(resolve => {
            $http.get("/models/" + modelId).then(resp => {
                commit("set", resp.data.model);
                resolve();
            });
        });
    },
    add(context, data) {
        let form_data = objectToFormData(data);
        return new Promise((resolve, reject) => {
            $http.post("/models", form_data, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    edit({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            $http.put("/models/" + data.id, {
                model: data
            }).then(resp => {
                commit("clear");
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    search(context, data) {
        return new Promise((resolve, reject) => {
            $http.get("/models", {
                params: data
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete({}, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/models/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    forceFileDownload({
        state
    }, response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", state.download.oldname); //or any other extension
        link.setAttribute("target", "_blank"); //or any other extension
        document.body.appendChild(link);
        link.click();
    },
    download({
        state,
        dispatch
    }, data) {
        $http({
            method: "get",
            url: "/models/download/" + data.id,
            responseType: "arraybuffer"
        }).then(response => {
            state.download = data;
            dispatch("forceFileDownload", response);
        }).catch(error => {
            console.log(error);
        });
    }
};

// mutations
const mutations = {
    setAll(state, models) {
        state.all = models;
    },
    set(state, model) {
        state.model = model;
    },
    clear(state) {
        state.model = [];
    },
    clearAll(state) {
        state.model = [];
        state.all = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
